<template>
  <div class="part-bottom bottom-bg" :style="`background-image: url(${bannerImg})`">
    <!-- <img :src="bannerImg" class="bottom-bg" alt=""> -->
    <!-- <div class="lw-flex is-align-middle is-justify-center part-bottom__content">
      <div class="part-bottom__content-title">想做就做，由此开始</div>
      <div class="part-bottom__content-tip">已为全球客户提供<span>2000</span>次服务</div>
    </div> -->
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState({
      configData: 'configData'
    }),
    bannerImg () {
      if (this.configData && this.configData.buttom) {
        return this.configData.buttom.image.configValue
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.part-bottom {
  position: relative;
  width: 100%;
  height: px2rem(300);
  &.bottom-bg {
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
  }
  &__content {
    position: relative;
    height: 100%;
    flex-direction: column;
    color: $--white-color;
    &-title {
      font-size: px2rem(48);
      margin-bottom: px2rem(14);
    }
    &-tip {
      font-size: px2rem(22);
      > span {
        color: #FF0000;
      }
    }
  }
}
</style>

